// extracted by css-extract-rspack-plugin
export default {"spinner":"spinner-x0_sys","spin":"spin-Xn2zuk","dark":"dark-bvVpmV"};